import React, { useMemo } from 'react';
import { useAccountManagersListQuery } from '../../../domain/filter-options/queries';
import Select from 'antd/lib/select';
import Empty from 'antd/lib/empty';

interface IAccountManagerSelectorProps {
    value: string | undefined;
    onChange?: (value: string) => void;
    companyId: number | null;
    includeNoAccountManager?: boolean;
    [key: string]: any;
}

const NO_ACCOUNT_MANAGER_OPTION: IOption = {
    label: 'No Account Manager',
    value: 'null',
    key: 'no-account-manager',
};

interface IOption {
    value: string | null;
    label: string;
    key: string;
}

const filterSelectorOption = (inputValue: string, option: IOption | undefined) => {
    const label = option?.label?.toString().toLowerCase() ?? '';
    return label.includes(inputValue.toLowerCase());
};

export const AccountManagerSelector: React.FC<IAccountManagerSelectorProps> = ({ value, onChange, companyId, includeNoAccountManager, ...props }) => {
    const { data: accountManagers, isFetching } = useAccountManagersListQuery({ company_id: companyId });

    const options: IOption[] = useMemo(() => {
        const accountManagerOptions: IOption[] = [];

        accountManagers?.forEach(accountManager => {
            accountManagerOptions.push({
                label: accountManager.value,
                value: accountManager.value,
                key: accountManager.value,
            });
        });

        return includeNoAccountManager && !companyId ? [NO_ACCOUNT_MANAGER_OPTION, ...accountManagerOptions] : accountManagerOptions;
    }, [includeNoAccountManager, accountManagers]);

    const handleChange = (newValue: unknown) => {
        if (onChange) onChange(newValue as string);
    };

    return (
        <Select
            allowClear
            showSearch
            size="large"
            options={options}
            value={value}
            onChange={handleChange}
            loading={isFetching}
            filterOption={(inputValue, option) => filterSelectorOption(inputValue, option as IOption)}
            placeholder="Select Account Manager"
            notFoundContent={<RenderEmptyAccountManagerList />}
            style={{ width: '200px' }}
            {...props}
        />
    );
};

const RenderEmptyAccountManagerList = () => {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Account Managers not found!" />;
};
